/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import dayjs from "dayjs";
import Config from "data/config";
import { useSimWebpage } from "hooks/use-sim-webpage";
import { useSimWebpageImage } from "hooks/use-sim-webpage-image";
import defaultNewsImage from "assets/images/default-news-component-image.png";

const DISPLAY_FORMAT = Config.dates.general_short;

/**
 * 
 * @param {string} dateString
 * @param {string} format
 */
const formatDate = (dateString, format) => {
    let formattedDate = "";

    if (dateString) {
        const dateFormat = format && format !== "field.format.none" ? format : DISPLAY_FORMAT;
        formattedDate = dayjs.utc(dateString).local().format(dateFormat);
    }

    return formattedDate;
};

const FeatureNewsItem = (props) => {
    const showDescription = props?.showDescription || false;
    const webpageGuid = props.webpage?.webpage;
    const { webpage } = useSimWebpage(webpageGuid);
    const { image } = useSimWebpageImage(webpageGuid);
    
    const imageUrl = image?.url || defaultNewsImage;
    const title = webpage?.nav_title || webpage?.title || "";
    const publishedAt = webpage?.published_at;
    const path = webpage?.path;
    const description = webpage?.description;
    const formattedDate = formatDate(publishedAt);
    
    const handleClick = () => {
        if (path) {
            const url = `${Config.previewUrl}${path}`;
            window.open(url, "_blank");
        }
    };
    
    return (
        <div 
            className="simplicity-news-highlights-feature-news-item"
            onClick={handleClick}
            style={{ cursor: path ? "pointer" : "default" }}
        >
            <div className="simplicity-news-highlights-feature-news-item-image">
                <img 
                    src={imageUrl} 
                    alt={title}
                    width={320}
                    height={213}
                />
            </div>
            <div className="simplicity-news-highlights-feature-news-item-content">
                {title && (
                    <div className="simplicity-news-highlights-feature-news-item-title">
                        {title}
                    </div>
                )}
                {showDescription && (
                    <div className="simplicity-news-highlights-feature-news-item-description">
                        {description}
                    </div>
                )}
                {formattedDate && (
                    <div className="simplicity-news-highlights-feature-news-item-date">
                        {formattedDate}
                    </div>
                )}
            </div>
        </div>
    );
};

FeatureNewsItem.displayName = "FeatureNewsItem";
export { FeatureNewsItem };
